var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.emitInput
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c7b9031", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c7b9031","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/components/form/textarea.vue
// module id = 293
// module chunks = 3